import * as http from '../../../vue_shared/http'
import { stringify } from '../../../vue_shared/query_params'

/* eslint-disable camelcase */
export interface CybersourceParms {
  invoice_id: number | string
}

export interface CybersourceFormData {
  signature: string
  access_key: string
  amount: number | string
  currency: string
  locale: string
  profile_id: string
  merchant_defined_data5: number | string
  reference_number: number | string
  signed_date_time: string
  signed_field_names: string[]
  transaction_type: string
  transaction_uuid: string
  unsigned_field_names: string
}

export interface CybersourceData {
  form_action: string
  params: CybersourceFormData
}

/* eslint-enable camelcase */

export async function fetchCybersourceData(
  params: CybersourceParms
): Promise<CybersourceData> {
  return http.get<CybersourceData>(
    `/client/payments/cybersource_data?${stringify(params)}`
  )
}
